import React from 'react'

const Lifestyle = () => {
  return (
    <div>Lifestyle</div>
  )
}

export default Lifestyle